"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dispatcher = void 0;
var Dispatcher = (function () {
    function Dispatcher() {
        this.services = {};
    }
    Dispatcher.prototype.register = function (dispatcher) {
        var svc = dispatcher.getSupportedService();
        if (svc in this.services) {
            return false;
        }
        this.services[svc] = dispatcher;
        return true;
    };
    Dispatcher.prototype.unregister = function (serviceName) {
        if (!(serviceName in this.services)) {
            return false;
        }
        delete this.services[serviceName];
        return true;
    };
    Dispatcher.prototype.dispatch = function (ctx, service, method, data) {
        if (!(service in this.services)) {
            throw new Error("Service '".concat(service, "' is not registered with the dispatcher."));
        }
        return this.services[service].dispatch(ctx, method, data);
    };
    return Dispatcher;
}());
exports.Dispatcher = Dispatcher;
//# sourceMappingURL=dispatcher.js.map